import React from 'react';

export default function DashBoard() {
  return (
    <div className="d-flex justify-content-center flex-column align-items-center h-100">
      <h2 className="mb-4">Admin Dashboard</h2>
        <p className="text-muted">Add charts, stats, or widgets here.</p>
    </div>
  );
}
